import { Skeleton } from 'primereact/skeleton';
import React from 'react';

type Props = {
  className?: string;
};

const OldUIReadonlyTextInputSkeleton: React.FC<Props> = ({ className }) => {
  return (
    <div className={className}>
      <Skeleton width="20rem" />
      <Skeleton height="50px" className="mt-2" />
    </div>
  );
};

export default OldUIReadonlyTextInputSkeleton;
